<template>
    <div class="symbol" :style="'background-color: ' + color + ';'"><!-- TODO: move to scoped style -->
      <img :alt="color + ' | ' + filling + ' | ' + shape" :src="'/shape_' + shape + '_' + filling + '.png'">
    </div>
</template>

<script>
export default {
  name: 'SingleSymbolPNG',
  props: {
    color: String, /* red | green | blue */
    shape: String, /* diamond | curved | pill */
    filling: String /* solid | pattern | hollow */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.symbol {
  border: none;

  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: width 3s;
  width: auto;
  height: 75%;

  img {
    /*width: 60px;
    height: 120px;*/
    height: 100%;
    width: auto;
    /*float: left;*/
    transition: width 3s;

    svg path {
      fill: blue;
    }
  }
}
</style>
